import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'

export const BOPSCNC = 'bopscnc'
export const BOSSSTS = 'bosssts'
export const DISTRIBUTION_CHANNEL = 'DistributionChannel'
export const MARKER_BLACK_URL = '/rbstatichtml/assets/images/icons/pin_dark.svg'
export const MARKER_GREY_URL = '/rbstatichtml/assets/images/icons/pin_grey.svg'
export const MARKER_RED_URL = '/rbstatichtml/assets/images/icons/pin_red.svg'
export const MARKER_BLACK_SGH = '/rbstatichtml/assets/images/icons/pin_sunglasshut.svg'
export const MARKER_BLACK_LENS_CRAFTERS = '/rbstatichtml/assets/images/icons/pin_lenscrafters.svg'
export const MARKER_UPS = '/rbstatichtml/assets/images/icons/pin_ups.png'
export const OMNI_LIMITED_INV_TRESHHOLD = 'omniLimitedInvTreshhold'
export const FINDSTORE = 'findStore'
export const SHIP_TO_STRAS = 'shipToStras'
export const PICKUP_IN_STORE_SHIPPING_METHOD = 'wcs-shipping-mode-pick-up-in-store-shipping'
export const SB = 'SB'
export const LC_ICO = 'lc-ico'
export const SHIP_TO_NAME_1 = 'shipToName1'
export const SHIP_TO_ORT_1 = 'shipToOrt1'
export const SHIPPING_ID = 'shippingId'
export const STOCK_AVL = 'stockAvl'
export const STORE_BRAND = 'storeBrand'
export const STORE_CLOSING_HOUR_THRESHOLD = 2
export const MARKER_ICON_HEIGHT = 36
export const MARKER_ICON_WIDTH = 32
export const RAYBAN_STORES_MARKER_ICON_HEIGHT = 56
export const RAYBAN_STORES_MARKER_ICON_WIDTH = 50
export const SUNGLASS_HUT = 'Sunglass Hut'
export const TIME_ZONE = 'timeZone'
export const ASTERISK = '*'
export const OPENED_AFTERPAY_MODAL_EVENT = 'openedAfterpayModalEvent'
export const SHIP_FROM_STORE_LOCATION = 'shipFromStoreLocation'

export const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export const DAYS_OF_WEEK_SHORT = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']

export const EUCountriesWithPhysicalStoresService = [
  WcsStoreId.ITALY,
  WcsStoreId.SPAIN,
  WcsStoreId.UNITED_KINGDOM,
]

export const NACountriesWithPhysicalStoresService = [WcsStoreId.USA, WcsStoreId.CANADA]

export const DAYS_OF_WEEK_EN_LABEL_IN_OPENING_HOURS = [
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
  'Sun',
]
export const DAYS_OF_WEEK_FR_CANADA_LABEL_IN_OPENING_HOURS = [
  'Lun',
  'Mar',
  'Mer',
  'Jeu',
  'Ven',
  'Sam',
  'Soleil',
]
export const DAYS_OF_WEEK_ITALY_LABEL_IN_OPENING_HOURS = [
  'Lun',
  'Mar',
  'Mer',
  'Gio',
  'Ven',
  'Sab',
  'Dom',
]
export const DAYS_OF_WEEK_SPAIN_LABEL_IN_OPENING_HOURS = [
  'Lun',
  'Mar',
  'Mié',
  'Jue',
  'Vie',
  'Sáb',
  'Dom',
]
